(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["epi-password-modal-engine"] && !Shopify.designMode) return;
  try {
    (function () {
  if (window.__pwModalEngineInit) return;
  window.__pwModalEngineInit = true;

  var openStack = [];

  function getFocusable(container) {
    return Array.prototype.slice
      .call(container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) {
        // getClientRects, not offsetParent: offsetParent is null for
        // position:fixed elements, which wrongly skipped the lookbook's
        // fixed close button and sent first focus into the grid.
        return !el.disabled && el.getClientRects().length > 0;
      });
  }

  function openModal(id) {
    var modal = document.querySelector('[data-modal="' + id + '"]');
    if (!modal) return;
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('epi-pw-modal-open');
    openStack.push(modal);
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
      var focusable = getFocusable(modal);
      modal._focusable = focusable;
      var toFocus = modal.querySelector('[autofocus]') || focusable[0];
      // preventScroll: the target can still be off-screen mid-slide-up;
      // a plain focus() scrolled the lookbook to it, so the sheet looked
      // like it started mid-screen and then dropped (iPhone).
      if (toFocus) {
        try { toFocus.focus({ preventScroll: true }); } catch (e) { toFocus.focus(); }
      }
    });
  }

  function closeModal(modal) {
    if (!modal) return;
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    var idx = openStack.indexOf(modal);
    if (idx > -1) openStack.splice(idx, 1);
    if (!openStack.length) document.body.classList.remove('epi-pw-modal-open');
    setTimeout(function () {
      modal.hidden = true;
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-modal]');
    if (opener) {
      e.preventDefault();
      openModal(opener.getAttribute('data-open-modal'));
      return;
    }
    var closer = e.target.closest('[data-modal-close]');
    if (closer) {
      closeModal(closer.closest('[data-modal]'));
      return;
    }
    if (e.target.matches('[data-modal-scrim]')) {
      closeModal(e.target.closest('[data-modal]'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (!openStack.length) return;
    var modal = openStack[openStack.length - 1];
    if (e.key === 'Escape') {
      closeModal(modal);
      return;
    }
    if (e.key === 'Tab') {
      var focusable = modal._focusable && modal._focusable.length ? modal._focusable : getFocusable(modal);
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  window.__pwModal = { open: openModal, close: closeModal };
})();
  } catch(e) { console.error(e); }
})();

})();
